import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import { Heart } from '@bibliocommons/deprecated-base-icons';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import SavedSearchModal from '../SavedSearchModal';
import './SaveSearchButton.scss';

const SAVED_SEARCH_MODAL_KEY = 'saved-search-modal';

export default class SaveSearchButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleOpen() {
    this.props.modalActions.openModal(SAVED_SEARCH_MODAL_KEY);
  }

  handleClose() {
    this.props.modalActions.closeModal(SAVED_SEARCH_MODAL_KEY);
  }

  render() {
    return (
      <div className="cp-save-search-button">
        <TextButton
          handleClick={this.handleOpen}
          className="save-search-text-button btn-link"
          data-test-id="save-search-link"
          dataKey="save-search-link"
        >
          <Heart />
          <FormattedMessage id="save_search" />
        </TextButton>

        <ModalContainer modalKey={SAVED_SEARCH_MODAL_KEY} handleClose={this.handleClose}>
          <SavedSearchModal
            handleClose={this.handleClose}
            savedSearch={this.props.savedSearch}
            savedSearchActions={this.props.savedSearchActions}
          />
        </ModalContainer>
      </div>
    );
  }
}

SaveSearchButton.propTypes = {
  savedSearch: ImmutablePropTypes.map.isRequired,
  savedSearchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
